import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../service/Interceptor";
import { ADMIN_API_ENDPOINTS, businessProfileCreationAPI } from "../service/apiUrl";

const initialState = {
  user: null,
  portfolioURL: "",
  profileURL: "",
  isLoading: false,
  hasError: false,
};

export const getUsers = createAsyncThunk("users", () => {});

export const businessProfileCreation = createAsyncThunk(
  "profile-creation",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await API.put(businessProfileCreationAPI, payload);

      if (res.data.success) {
        return true;
      } else {
        return rejectWithValue("Profile creation failed");
      }
    } catch (error) {
      console.log("Profile creation error", error);
      return rejectWithValue("Something went wrong");
    }
  }
);

export const userDetails = createAsyncThunk(
  "profile-details",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await API.get(ADMIN_API_ENDPOINTS.USERDETAILS);

      if (res.data.success) {
        return res.data;
      } else {
        return rejectWithValue("Profile user failed");
      }
    } catch (error) {
      console.log("Profile user error", error);
      return rejectWithValue("Something went wrong");
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //------------------GET ALL USERS------------------
      .addCase(getUsers.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(userDetails.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(userDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(userDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      });

    //------------------UPLOAD PROFILE IMAGE------------------
    // .addCase(uploadProfileImage.pending, (state, action) => {
    //   state.isLoading = true;
    //   state.hasError = false;
    // })
    // .addCase(uploadProfileImage.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.hasError = true;
    // })
    // .addCase(uploadProfileImage.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.hasError = false;
    //   state.profileURL = action.payload;
    // })
  },
});

export default usersSlice.reducer;
